import Messages from './messages.js'

/**
 * Represents a custom object returned by the device info.
 * 
 * @typedef {Object} DeviceInfo
 * @property {string} serial - Serial no of board
 * @property {string} model - Model no of board
 * @property {string} mac - MAC address
 * @property {string} publickKey - Public key of board
 */

export default class RpiClient {

  constructor(socket) {
    this.socket = socket
  }

  /**
   * Get device info
   * 
   * @param {boolean} resetKeys - Whether to reset keys or not
   * @returns {Promise<DeviceInfo>}
   */
  async deviceInfo(resetKeys) {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Rpi_DeviceInfo, resetKeys);
    } catch (error) {
      console.error(`RpiClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return response.data
  }

  /**
   * Power off RPI
   * 
   * @returns {Promise<void>}
   */
  async powerOff() {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Rpi_PowerOff);
    } catch (error) {
      console.error(`RpiClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return
  }

  /**
  * Reboot RPI
  * 
  * @returns {Promise<void>}
  */
  async reboot() {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Rpi_Reboot);
    } catch (error) {
      console.error(`RpiClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return
  }
}